import { styled } from 'styled-components'

// Custom SVG wrapper for VariableIcon with specific viewBox
const StyledSvg = styled.svg.attrs({ viewBox: '0 0 13 10' })`
  width: 1em;
  height: 1em;
  font-size: inherit;
  fill: currentcolor;
`

const VariableIcon = () => (
  <StyledSvg>
    <path
      d='M8 9.6V8.4H9.4C9.57 8.4 9.7125 8.3425 9.8275 8.2275C9.9425 8.1125 10 7.97 10 7.8V6.6C10 6.14444 10.1528 5.75278 10.4583 5.425C10.7639 5.09722 11.1444 4.90555 11.6 4.85V4.78333C11.1444 4.69444 10.7639 4.48889 10.4583 4.16667C10.1528 3.84444 10 3.45555 10 3V1.8C10 1.63 9.9425 1.4875 9.8275 1.3725C9.7125 1.2575 9.57 1.2 9.4 1.2H8V0H9.4C9.9 0 10.325 0.175 10.675 0.525C11.025 0.875 11.2 1.3 11.2 1.8V3C11.2 3.17 11.2575 3.3125 11.3725 3.4275C11.4875 3.5425 11.63 3.6 11.8 3.6H12.8V6H11.8C11.63 6 11.4875 6.0575 11.3725 6.1725C11.2575 6.2875 11.2 6.43 11.2 6.6V7.8C11.2 8.3 11.025 8.725 10.675 9.075C10.325 9.425 9.9 9.6 9.4 9.6H8ZM3.4 9.6C2.9 9.6 2.475 9.425 2.125 9.075C1.775 8.725 1.6 8.3 1.6 7.8V6.6C1.6 6.43 1.5425 6.2875 1.4275 6.1725C1.3125 6.0575 1.17 6 1 6H0V3.6H1C1.17 3.6 1.3125 3.5425 1.4275 3.4275C1.5425 3.3125 1.6 3.17 1.6 3V1.8C1.6 1.3 1.775 0.875 2.125 0.525C2.475 0.175 2.9 0 3.4 0H4.8V1.2H3.4C3.23 1.2 3.0875 1.2575 2.9725 1.3725C2.8575 1.4875 2.8 1.63 2.8 1.8V3C2.8 3.46667 2.64722 3.86389 2.34167 4.19167C2.03611 4.51944 1.65556 4.71111 1.2 4.76667V4.83583C1.65556 4.87861 2.03611 5.06667 2.34167 5.4C2.64722 5.73333 2.8 6.13333 2.8 6.6V7.8C2.8 7.97 2.8575 8.1125 2.9725 8.2275C3.0875 8.3425 3.23 8.4 3.4 8.4H4.8V9.6H3.4Z'
      fill='currentColor'
    />
    <path
      d='M8.40039 4.7998C8.40039 5.90437 7.50496 6.7998 6.40039 6.7998C5.29582 6.7998 4.40039 5.90437 4.40039 4.7998C4.40039 3.69524 5.29582 2.7998 6.40039 2.7998C7.50496 2.7998 8.40039 3.69524 8.40039 4.7998Z'
      fill='currentColor'
    />
  </StyledSvg>
)

export default VariableIcon
